import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import translate from '@/lib/intl/translate';
import GroupingType from '../constants/GroupingType';

export default function QuickFilterGroupedOpportunities() {
  const { control } = useFormContext();

  return (
    <div className="grid w-72 grid-cols-1 gap-3 pt-3">
      <span className="inline-block px-2 text-grey-900 type-body4">
        {translate('OPPORTUNITIES_GROUP_BY_LABEL')}
      </span>

      <Controller
        control={control}
        name="groupingType"
        render={({ field: { onChange, value } }) => (
          <MenuList className="p-0">
            <MenuItem
              className="px-2.5 py-3"
              onClick={() => onChange(GroupingType.NONE)}
              selected={value === GroupingType.NONE}
            >
              {translate('OPPORTUNITIES_GROUP_BY_NONE')}
            </MenuItem>
            <MenuItem
              className="px-2.5 py-3"
              onClick={() => onChange(GroupingType.CONFIDENCE_LEVEL)}
              selected={value === GroupingType.CONFIDENCE_LEVEL}
            >
              {translate('OPPORTUNITIES_GROUP_BY_CONFIDENCE_LEVEL')}
            </MenuItem>
            <MenuItem
              className="px-2.5 py-3"
              onClick={() => onChange(GroupingType.STAGE)}
              selected={value === GroupingType.STAGE}
            >
              {translate('OPPORTUNITIES_GROUP_BY_STAGE')}
            </MenuItem>
          </MenuList>
        )}
      />
    </div>
  );
}
